export class HomeDetails {
    message: string;
    firstName: string;
    lastName: string;
    location: string;
    locale: string;
    gender: string;
    pictureUrl: string;
    facebookId: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/home-details.ts